<template>
  <div id="app" :style="layoutColours || {}" :class="{ customLayout: (layout == 'custom')}">
    <loading
      id="page-loading-spinner"
      v-if="this.$route.name != 'login'"
      class="align-items-center"
      :active.sync="isPageLoading"
      :can-cancel="false"
      :color="'#047bf8'"
      :loader="'spinner'"
      :is-full-page="true">
    </loading>
    <router-view :key="routeQueryChange"/>
    <a v-if="feedBackButtonAvailable" href="javascript:;" @click="openFeedbackModal()" class="feedback-btn" title="Feedback">
      <i class="os-icon os-icon-mail-18 increase-font"></i>
    </a>
    <b-modal v-if="loggedIn && clientName != 'gskp' && clientName != 'gskptest'" id="feedback-modal" size="lg" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @hide="hideFeedbackOverlay()">
      <template slot="modal-header" slot-scope="{ close }">
        <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'marker']" size="1x" class="mr-2"/> {{ t('feedbackModalTitle', 'feedbackModalTitle') }}</h5>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
      </template>
      <template slot="default" slot-scope="{ close }">
        <b-form-group id="input-group-1" label="Subject:" label-for="input-1">
          <b-form-input id="input-1" v-model="feedbackData.subject" type="text" required placeholder="Enter subject"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2" label="Message:" label-for="input-2">
          <b-form-textarea id="input-2" v-model="feedbackData.message" type="text" required placeholder="Enter message" rows="3" max-rows="6"></b-form-textarea>
        </b-form-group>
      </template>
      <template slot="modal-footer" slot-scope="{ cancel, close }">
          <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
            <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
          </button>
          <button aria-label="AcceptAllDocs" data-dismiss="modal" class="btn btn-primary" type="button" :disabled="sendingFeedback || formFilled" @click="sendFeedback()">
            <fontAwesomeIcon :icon="['fa', 'thumbs-up']" class="text-light mr-2"/> {{ t('sendFeedbackBtn', 'sendFeedbackBtn')}}
          </button>
      </template>
      <ResponseInfo v-if="getResponseInfo.responseName == 'feedbackModal'"></ResponseInfo>
    </b-modal>

    <UserAgreementModal />
    <div class="modal-backdrop show" v-if="feedbackOverlayActive || agreementOverlayActive"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { clientShortName } from '@/helpers/clientShortName.js'
import Loading from 'vue-loading-overlay'
import ResponseInfo from '@/components/ResponseInfo.vue'
import UserAgreementModal from '@/components/Helper_Components/UserAgreementModal.vue'

export default {
  name: "App",
  data() {
    return {
      feedbackOverlayActive: false,
      agreementOverlayActive: false,
      sendingFeedback: false,
      feedbackData: {
        subject: '',
        message: ''
      },
      routeQueryChange: 0
    }
  },
  components: {
    Loading,
    ResponseInfo,
    UserAgreementModal
  },
  watch: {
    $route (to, from) {
      if (
          to.path === from.path
          && Object.keys(to.query).length === 0
          && Object.keys(from.query).length !== 0
      ) {
        this.routeQueryChange += 1
      }
    }
  },
  created() {
    let userLang = navigator.language || navigator.userLanguage;
    //this.$store.dispatch('setUserLocal', userLang).then(() => {})
  },
  updated(){
    setTimeout( () => this.$store.commit('setPageLoading', false), 2000)
  },
  methods: {
    showAgreementModal() {
      this.agreementOverlayActive = true
      this.$root.$emit('bv::show::modal', 'agreement-modal')
    },
    openFeedbackModal() {
      this.feedbackOverlayActive = true
      this.$root.$emit('bv::show::modal', 'feedback-modal')
    },

    hideFeedbackOverlay() {
      this.feedbackOverlayActive = false
    },

    hideAgreementModal() {
      this.agreementOverlayActive = false
      this.$root.$emit('bv::hide::modal', 'agreement-modal')
    },

    sendFeedback() {
      if(this.loggedIn) {
        this.sendingFeedback = true
        this.$store.dispatch('sendFeedback', this.feedbackData).then(() => {
          this.sendingFeedback = false
          this.feedbackData.subject = ''
          this.feedbackData.message = ''
          this.$root.$emit('bv::hide::modal', 'feedback-modal')
        })
      }
    }
  },
  computed: {
    ...mapGetters(['getLayout', 'getLayoutColours', 'isPageLoading', 'getResponseInfo', 'loggedIn', 'templateDetails', 'getUserLevel']),
    clientName() {
      let clientName = clientShortName()
      return clientName
    },
    layout: {
        get() {
            return this.$store.getters.getLayout.layout
        }
    },
    colours: {
        get() {
            return this.$store.getters.getLayoutColours
        }
    },
    formFilled() {
      if(this.feedbackData != undefined) {
          let subject = this.feedbackData.subject
          let message = this.feedbackData.message
          if(subject || message) {
            return false
          } else {
            return true
          }
      } else {
        return true
      }
    },
    layoutColours() {
        var layout = this.layout

        if(layout == undefined) {
          this.$store.dispatch('getSiteAppearanceSettings')
          .then(() => {
            layout = this.$store.getters.getLayout.layout
          })
        }

        if(layout == 'custom'){
            if(Object.keys(this.colours).length){
                // we should get the colours from the vuex state when we log in
                return {
                    '--colour-header-bg': this.colours.colour_header_bg,
                    '--colour-nav-bg': this.colours.colour_nav_bg,
                    '--colour-nav-text': this.colours.colour_nav_text,
                    '--colour-menu-text': this.colours.colour_menu_text,
                    '--colour-menu-active-text': this.colours.colour_menu_active_text,
                    //'--colour-th': appearanceColours.colour_th,
                    //'--colour-th-text': appearanceColours.colour_th_text,
                    '--colour-menu-inner': this.colours.colour_menu_inner,
                    '--colour-menu-outer': this.colours.colour_menu_outer,
                    '--colour-menu-active': this.colours.colour_menu_active,
                    '--colour-pagination': this.colours.colour_pagination,
                    //'--colour-notify': appearanceColours.colour_notify,
                    //'--colour-notify-text': appearanceColours.colour_notify_text,
                    '--colour-active-tab-bg': this.colours.colour_active_tab_bg,
                    //'--colour-active-tab-text': appearanceColours.colour_active_tab_text,
                    //'--colour-inactive-tab-bg': appearanceColours.colour_inactive_tab_bg,
                    //'--colour-inactive-tab-text': appearanceColours.colour_inactive_tab_text
                  }
            }else{
                var appearanceColours = JSON.parse(localStorage.getItem('appearanceColours'))
                if(appearanceColours){
                    // In case we can't get the colours from the vuex state, we try to fetch them from local storage
                    return {
                        '--colour-header-bg': appearanceColours.colour_header_bg,
                        '--colour-nav-bg': appearanceColours.colour_nav_bg,
                        '--colour-nav-text': appearanceColours.colour_nav_text,
                        '--colour-menu-text': appearanceColours.colour_menu_text,
                        '--colour-menu-active-text': appearanceColours.colour_menu_active_text,
                        //'--colour-th': appearanceColours.colour_th,
                        //'--colour-th-text': appearanceColours.colour_th_text,
                        '--colour-menu-inner': appearanceColours.colour_menu_inner,
                        '--colour-menu-outer': appearanceColours.colour_menu_outer,
                        '--colour-menu-active': appearanceColours.colour_menu_active,
                        '--colour-pagination': appearanceColours.colour_pagination,
                        //'--colour-notify': appearanceColours.colour_notify,
                        //'--colour-notify-text': appearanceColours.colour_notify_text,
                        '--colour-active-tab-bg': appearanceColours.colour_active_tab_bg,
                        //'--colour-active-tab-text': appearanceColours.colour_active_tab_text,
                        //'--colour-inactive-tab-bg': appearanceColours.colour_inactive_tab_bg,
                        //'--colour-inactive-tab-text': appearanceColours.colour_inactive_tab_text
                    }
                }else{
                    // the first time we load the App.vue,
                    // we don't get the colours so we return an empty object instead
                    return {}
                }
            }
          }
    },
    feedBackButtonAvailable: {
      get() {
       return (
           this.loggedIn
           && this.clientName !== 'gskp' && this.clientName !== 'gskptest'
           && this.clientName !== 'warm' && this.clientName !== 'warmtest'
           && this.clientName !== 'kmps' && this.clientName !== 'kmpstest'
           && this.getUserLevel >= 2.00
       )
      }
    }
  }
}

</script>


<style>
#agreement-modal {
  z-index: 10000;
}

.auth-box-w .logo-w {
  padding: 10% 20% 10% 20% !important
}

.menu-position-top.menu-w.menu-with-image .menu-page-header {
  padding: 5px 20px 5px 20px !important;
}

#app {
  min-height: 100vh;
  position: relative;
}

#app > div {
  min-height: 100vh;
}

/******************ERROR MSG**********************/
  .form-success {
    width: 90%;
    border: 1px solid;
    padding: 10px;
    display: inline-block;
    background-color: rgba(0, 255, 0, 0.1);
    margin-bottom: 0px;
  }
  .form-success-box {
      text-align: center;
      color: green;
      width:100%;
      height: auto;
      border-radius: 5px;
  }
    .form-error {
    width: 90%;
    border: 1px solid;
    padding: 10px;
    display: inline-block;
    background-color: rgba(255, 0, 0, 0.1);
    margin-bottom: 0px;
  }
  .form-error-box {
    text-align: center;
    color:red;
    width:100%;
    height: auto;
    border-radius: 5px;
  }

/******************ERROR MSG**********************/

/*****************SITE SETUP APPEARANCE COLOURS**/
.customLayout .colour-header-bg{
  background-color: var(--colour-header-bg) !important;
}

/* Main menu */
.customLayout .colour-nav-bg{
  background-color: var(--colour-nav-bg) !important;
}
.customLayout .colour-nav-text{
  color: var(--colour-nav-text);
}
.customLayout .colour-hover, .customLayout .has-active .colour-hover{
  background-color: var(--colour-nav-bg) !important;
}
.customLayout li.has-sub-menu.active > a{
  background-color: var(--colour-menu-inner) !important;
}
.customLayout .colour-hover::before{
  color: var(--colour-nav-text) !important;
}
.customLayout .has-active li.has-sub-menu.active .colour-hover::before{
  color: var(--colour-menu-text) !important;
}
.customLayout .has-active li.has-sub-menu.active{
  border-right-color: var(--colour-menu-inner) !important;
  border-bottom-color: var(--colour-menu-inner) !important;
}
.customLayout .has-active li.has-sub-menu.active .colour-nav-text{
  color: var(--colour-menu-text) !important;
}

/* Main menu MOBILE */
.customLayout .menu-mobile.color-scheme-dark{
  background-color: var(--colour-nav-bg) !important;
}
.customLayout .menu-mobile.color-scheme-dark .sub-menu li::marker{
  color: var(--colour-menu-text) !important;
}
.customLayout .menu-mobile.color-scheme-dark .has-sub-menu.active .colour-nav-text{
  color: var(--colour-menu-text) !important;
}
.customLayout .menu-mobile.color-scheme-dark .has-sub-menu.active .colour-hover::before{
  color: var(--colour-menu-text) !important;
}


/* Sub Menu */
.customLayout .sub-menu-w{
  background-color: var(--colour-menu-inner) !important;
}
.customLayout .sub-menu-text{
  color: var(--colour-menu-text) !important;
}
.customLayout .sub-menu-text::before{
  background-color: var(--colour-menu-text) !important;
  border-color: var(--colour-menu-text) !important;
}

/* side menu */
.customLayout .menu-w .logged-user-menu.color-style-bright{
  background-color: var(--colour-nav-bg) !important;
}
.customLayout .menu-w .logged-user-menu .logged-user-info-w .logged-user-name{
  color: var(--colour-nav-text);
}
.customLayout .menu-w .avatar-w .os-icon{
  color: var(--colour-nav-text);
}
.customLayout .menu-w .logged-user-menu ul li a{
  color: var(--colour-nav-text);
}
.customLayout .logged-user-menu .form-control:focus{
  border-color: var(--colour-nav-bg) !important;
}
/*****************SITE SETUP APPEARANCE COLOURS**/
/*****************PAGE LOAD SPINNER*************/
#page-loading-spinner{
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index:10000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: white;
}
/*****************PAGE LOAD SPINNER*************/
#widget-loading-spinner{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: flex;
  opacity: 0.6;
  flex-direction: column;
  justify-content: center;
  background-color: white;
  transition: opacity 0.5s linear;
  right: 0;
  left: 0;
}

.feedback-btn {
  position: fixed;
  right: 10px;
  bottom: 10px;
  right: 50px;
  bottom: 100px;
  text-decoration: none;
  outline: none;
}

.feedback-btn:hover {
  text-decoration: none;
}

.feedback-btn > i {
  color: #047bf8;
  font-size: 30px;
  transition: font-size 1s;
}

.increase-font:hover {
  font-size: 50px;
  text-decoration: none;
}

/* NS-10331 Horizontal overflow in case content does not fit */
/*#app {*/
/*  overflow-x: auto;*/
/*}*/

/*EIPP-244, Double scroll bar removed, RS*/
#app {
  overflow-x: clip;
}

</style>
